module.exports = __webpack_public_path__ + "static/media/Vector.21c7d18b.png";